//getUserWoAssTask
import _axios from '../../../util/axios/AxiosConfig'

export function getStatistic(type){
    return _axios({
        url: `/api/Statistic/getHomePage?type=${type}`,
        method: 'get'
    })
}

//getHomePageDetail
export function getHomePageDetail(type,startDate,endDate,finishType){
    return _axios({
        url: `/api/Statistic/getHomePageDetail?type=${type}&startDate=${startDate}&endDate=${endDate}&finishType=${finishType}`,
        method: 'get'
    })
}